import { render, staticRenderFns } from "./index.vue?vue&type=template&id=925c3738&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=925c3738&prod&scoped=true&lang=css"
import style1 from "../../../sass/partials/sidebar-submenu.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925c3738",
  null
  
)

export default component.exports